import { z } from 'zod';

export const organizationItemSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
});

export const organizationListSchema = z.array(organizationItemSchema);

export type OrganizationItem = z.infer<typeof organizationItemSchema>;

export interface DepartmentListParams {
  companyId?: number | undefined;
}
